import BicycleIcon from '@/ui-cvi/components/dxp-icons/system/BicycleIcon'
import BusIcon from '@/ui-cvi/components/dxp-icons/system/BusIcon'
import CampervanIcon from '@/ui-cvi/components/dxp-icons/system/CampervanIcon'
import CaravanIcon from '@/ui-cvi/components/dxp-icons/system/CaravanIcon'
import CarIcon from '@/ui-cvi/components/dxp-icons/system/CarIcon'
import CarRoofBoxIcon from '@/ui-cvi/components/dxp-icons/system/CarRoofBoxIcon'
import CarTrailerIcon from '@/ui-cvi/components/dxp-icons/system/CarTrailerIcon'
import MotorcycleIcon from '@/ui-cvi/components/dxp-icons/system/MotorcycleIcon'
import MotorcycleSidecarIcon from '@/ui-cvi/components/dxp-icons/system/MotorcycleSidecarIcon'

export const isFootPassenger = (vehicleCode: string): boolean => {
  return vehicleCode === 'NCAR'
}

export const getVehicleIcon = (vehicleCode: string): any => {
  switch (vehicleCode) {
    case 'BIKV':
      return BicycleIcon
    case 'CAR':
    case 'CARH':
    case 'CARLW':
      return CarIcon
    case 'CARZ':
    case 'CARX':
      return CarRoofBoxIcon
    case 'MCVB':
    case 'MCVM':
    case 'MCVX':
    case 'MCVS':
    case 'PVANB':
    case 'PVANM':
      return CampervanIcon
    case 'MIBUS':
      return BusIcon
    case 'MOC':
      return MotorcycleIcon
    case 'MOCS':
      return MotorcycleSidecarIcon
    case 'CAMB':
    case 'CAMS':
      return CaravanIcon
    case 'TRAB':
    case 'TRAS':
    case 'TRAZ':
      return CarTrailerIcon
    default:
      return null
  }
}
